var map = {
	"./transvlogin/transvlogin.module": [
		"./src/app/transvlogin/transvlogin.module.ts",
		"default~transvlogin-transvlogin-module~transvmanager-transvmanager-module",
		"transvlogin-transvlogin-module"
	],
	"./transvmanager/transvmanager.module": [
		"./src/app/transvmanager/transvmanager.module.ts",
		"default~transvlogin-transvlogin-module~transvmanager-transvmanager-module",
		"transvmanager-transvmanager-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;